const CopyRight = () => {
  return <div className="text-xs p-theme-md text-center ">© {new Date().getFullYear()} - Crayon | Todos los derechos reservados</div>;
};

export default CopyRight;
